
		<ng-container #menuContainer></ng-container>
		<ng-template #menuTemplate>
			<div class="sh-context-menu">
				<div
					*ngFor="let menuItem of menuItems"
					#itemElement
					[ngClass]="{
						'sh-sub-anchor': menuItem.subMenu,
						'sh-context-menu--item__divider': menuItem.divider,
						'sh-context-menu--item__sub-active': subActive && menuItem.active
					}"
					class="sh-context-menu--item"
					(mouseenter)="onEnter($event, menuItem, itemElement)"
					(click)="onClick($event, menuItem)"
				>
					<ng-container *ngIf="!menuItem.divider || !isVisible(menuItem)">
						<ng-content
							*ngTemplateOutlet="menuItem.template; context: menuItem.context"
						></ng-content>
					</ng-container>
				</div>
			</div>
		</ng-template>
	